
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': '全般',
	'widgetId': 'ウィジェット ID',
	'widgetType': 'ウィジェット・タイプ',
	'serviceability': '保守容易性',
	'copyButton': 'コピー',
	'closeButton': '閉じる',
	'specification': '仕様',
	'viewSpecification': 'ビューの仕様'
});
